import apiPaths from 'config/apiPaths';

import axiosInstance from './axios';

export type MessageRequest = {
  userId: string;
  content: string;
};

export const sendMessage = (message: MessageRequest): Promise<void> => axiosInstance.post(apiPaths.MESSAGES, message);
